/**
 * A documentation page's id is its slug (e.g. `clients/mandates`). Ids written
 * while docs had a language folder carried a locale prefix (`en_GB:clients`),
 * and saved chat messages and AI threads still hold them, so a prefix is
 * stripped wherever a stored id is read back.
 */
export function docSlugFromPageId(pageId: string): string {
  return pageId.replace(/^[a-z]{2}_[A-Z]{2}:/, "");
}
